import { put, select, race, take, call, delay } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actionTypes from '../actions/actionTypes';
import * as actions from '../actions';

export function* createIOTssidNetworkSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const requestBody = {
        wifiSsidName: action.info.ssid,
        wifiSsidPassphrase: action.info.ssidPassword,
        enabled: action.info.enabled,
        broadcast: action.info.ssidBroadcast,
        ssidnumberOfUnits: action.info.numberOfUnits || 0,
        numberOfBuildings: action.info.numberOfBuildings || 0,
        wifiType: action.info.wifiType,
        masterAcct,
        configType: action.info.configType
      };
      yield put({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: true });
      const isPatch = action.info.method === 'patch';
      const response = isPatch
        ? yield axios.patch('/updateIOTNetwork', requestBody)
        : yield axios.post('/createIOTNetwork', requestBody);
      if (response.data?.status === 200) {
        yield put(actions.createIOTssidNetworkSuccess(response.data));
        yield put(actions.getIOTssidNetworkDetails(action.info.wifiType));
      } else if (response.data?.status === 404) {
        yield put(actions.createIOTssidNetworkFailed({ message: response.data?.message }));
      } else {
        yield put(actions.createIOTssidNetworkFailed());
      }
      yield put({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: false });
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to create IOT network.');
      yield put(actions.createIOTssidNetworkFailed({ status, message }));
      yield put({ type: actionTypes.CREATE_IOT_SSID_NETWORK_LOADING, isLoading: false });
    }
  } else {
    yield put(actions.setSecondSsidInfoFailed());
  }
}

export function* getIOTssidNetworkDetailsSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const wifiType = action.wifiType;
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
      try {
        yield put({type: actionTypes.GET_IOT_SSID_NETWORK_LOADING})
       const response = yield axios.get(
          '/getIOTNetwork',
          {
         params: {
          wifiType : wifiType,
          masterAcct
        }
      }
        )

        if (response?.data?.status === 200) {
          yield put(actions.getIOTssidNetworkSuccess(response?.data));
        } else {
          yield put(actions.getIOTssidNetworkFailed());
        }
      } catch (error) {
        const status = error?.response?.status || error?.response?.data?.status || 0;
        const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to load IOT network.');
        yield put(actions.getIOTssidNetworkFailed({ status, message }));
      }
    }
  }

export function* getallIOTssidNetworkDetailsSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const wifiType = action.wifiType;
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS_LOADING });
      const response = yield axios.get('/getallIOTssidNetwork', { params: { wifiType, masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getIOTssidNetworkSuccess(response?.data));
      } else {
        yield put(actions.getIOTssidNetworkFailed());
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to load IOT network.');
      yield put(actions.getIOTssidNetworkFailed({ status, message }));
    }
  }
}

export function* getNetworksSaga() {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_NETWORKS_LOADING });
      const response = yield axios.get('/getNetworks', { params: { masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getNetworksSuccess(response.data));
        const data = response.data;
        const networks = Object.keys(data)
          .filter(key => !isNaN(key))
          .map(key => data[key]);
        if (networks.length > 0) {
          const currentSelected = yield select(state => state.propertyIOTNetwork.selectedNetwork);
          const currentType = currentSelected?.wifiType;
          const matchedNetwork = currentType && networks.find(n => n.wifiType === currentType);
          const defaultNetwork = matchedNetwork || networks.find(n => n.wifiType === 'IOT') || networks[0];
          yield put(actions.setSelectedNetwork(defaultNetwork));
        }
      } else {
        yield put(actions.getNetworksFail());
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to load networks.');
      yield put(actions.getNetworksFail({ status, message }));
    }
  }
}

export function* getNetworkDevicesSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_NETWORK_DEVICES_LOADING });
      const response = yield axios.get('/getIOTNetworkDevices', {
        params: { wifiType: action.payload, masterAcct },
        validateStatus: () => true
      });
      if (response?.data?.status === 200) {
        yield put(actions.getNetworkDevicesSuccess(response.data.devices || []));
      } else {
        yield put(actions.getNetworkDevicesFail({
          status: response?.data?.status || response?.status,
          message: response?.data?.message || response?.data?.error || 'An error occurred'
        }));
      }
    } catch (error) {
      const status = error?.response?.status || 0;
      yield put(actions.getNetworkDevicesFail({
        status: status,
        message: error?.response?.data?.message || 'An error occurred'
      }));
    }
  }
}

export function* updateNetworkSaga(action) {
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.UPDATE_NETWORK_LOADING });
      const response = yield axios.patch('/updateNetwork', { ...action.payload });
      if (response?.data?.status === 200) {
        yield put(actions.updateNetworkSuccess(action.payload));
      } else {
        yield put(actions.updateNetworkFail());
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to update network.');
      yield put(actions.updateNetworkFail({ status, message }));
    }
  }
}

export function* deleteNetworkSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.DELETE_NETWORK_LOADING });
      const response = yield axios.delete('/deleteIOTNetwork', { data: { ...action.payload, bulkMasterAccount: masterAcct } });
      if (response?.data?.status === 204) {
        yield put(actions.deleteNetworkSuccess());
        yield put(actions.getNetworks());
      } else {
        yield put(actions.deleteNetworkFail());
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to delete network.');
      yield put(actions.deleteNetworkFail({ status, message }));
    }
  }
}

export function* getGuestNetworkSessionSaga(action) {
  const masterAcct = action.masterAcct || (yield sessionStorage.getItem('masterAcct'));
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_GUEST_NETWORK_SESSION_LOADING });
      const response = yield axios.get('/getGuestNetworkSession', { params: { masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getGuestNetworkSessionSuccess(response.data));
      } else {
        yield put(actions.getGuestNetworkSessionFail({ status: response?.data?.status, message: response?.data?.message || 'Failed to load session settings.' }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (error?.request ? 'Network error. Please check your connection.' : 'Internal Server Error.');
      yield put(actions.getGuestNetworkSessionFail({ status, message }));
    }
  }
}

export function* updateGuestNetworkSessionSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.UPDATE_GUEST_NETWORK_SESSION_LOADING });
      const response = yield axios.patch('/updateGuestNetworkSession', { ...action.payload, masterAcct });
      if (response?.data?.status === 200) {
        yield put(actions.setGuestSessionPolling(true));
        yield race({
          task: call(guestSessionPollingWorker, masterAcct),
          cancel: take(actionTypes.STOP_GUEST_SESSION_POLLING)
        });
        yield put(actions.setGuestSessionPolling(false));
      } else {
        const status = response?.data?.status || response?.status;
        const message = response?.data?.message || 'Failed to update session settings.';
        yield put(actions.updateGuestNetworkSessionFail({ status, message }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || error?.response?.data?.error || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to update session settings.');
      yield put(actions.updateGuestNetworkSessionFail({ status, message }));
    }
  }
}

function* guestSessionPollingWorker(masterAcct) {
  const INITIAL_DELAY = 15000;
  const POLL_INTERVAL = 5000;
  const TIMEOUT = 90000;
  const startTime = Date.now();

  yield delay(INITIAL_DELAY);

  while (Date.now() - startTime < TIMEOUT) {
    try {
      const response = yield axios.get('/getGuestNetworkSession', { params: { masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getGuestNetworkSessionSuccess(response.data));
        yield put(actions.updateGuestNetworkSessionSuccess(response.data));
        return;
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || error?.response?.data?.error || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to apply session settings.');
      yield put(actions.updateGuestNetworkSessionFail({ status, message }));
      return;
    }
    yield delay(POLL_INTERVAL);
  }
  yield put(actions.updateGuestNetworkSessionFail({ status: 408, message: 'Session settings could not be applied within the expected time. Please try again.' }));
}

export function* getGuestNetworkScheduleSaga(action) {
  const masterAcct = action.masterAcct || (yield sessionStorage.getItem('masterAcct'));
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_GUEST_NETWORK_SCHEDULE_LOADING });
      const response = yield axios.get('/getGuestNetworkSchedule', { params: { masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getGuestNetworkScheduleSuccess(response.data));
      } else {
        yield put(actions.getGuestNetworkScheduleFail({ status: response?.data?.status, message: response?.data?.message || 'Failed to load schedule settings.' }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (error?.request ? 'Network error. Please check your connection.' : 'Internal Server Error.');
      yield put(actions.getGuestNetworkScheduleFail({ status, message }));
    }
  }
}

export function* updateGuestNetworkScheduleSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE_LOADING });
      const response = yield axios.patch('/updateGuestNetworkSchedule', { ...action.payload, masterAcct });
      if (response?.data?.status === 200) {
        yield put(actions.updateGuestNetworkScheduleSuccess(response.data));
      } else {
        const status = response?.data?.status || response?.status;
        const message = response?.data?.message || 'Failed to update schedule settings.';
        yield put(actions.updateGuestNetworkScheduleFail({ status, message }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || error?.response?.data?.error || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to update schedule settings.');
      yield put(actions.updateGuestNetworkScheduleFail({ status, message }));
    }
  }
}

export function* getNetworkDevicePauseStateSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE_LOADING });
      const response = yield axios.get('/getPauseStateDevice', {
        params: { deviceMac: action.payload.macAddress, wifiType: action.payload.wifiType, masterAcct },
        validateStatus: () => true
      });
      if (response?.data?.status === 200) {
        yield put(actions.getNetworkDevicePauseStateSuccess(response.data));
      } else {
        yield put(actions.getNetworkDevicePauseStateFail({ status: response?.data?.status, message: response?.data?.message || 'Failed to load pause state.' }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'An error occurred.');
      yield put(actions.getNetworkDevicePauseStateFail({ status, message }));
    }
  }
}

export function* pauseNetworkDeviceSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.PAUSE_NETWORK_DEVICE_LOADING });
      const response = yield axios.patch('/pauseDevice', null, {
        params: { masterAcct, wifiType: action.payload.wifiType, deviceMac: action.payload.macAddress },
        validateStatus: () => true
      });
      if (response?.data?.status === 204) {
        yield put(actions.pauseNetworkDeviceSuccess(response.data));
        yield put(actions.getNetworkDevicePauseState({ macAddress: action.payload.macAddress, wifiType: action.payload.wifiType }));
      } else {
        yield put(actions.pauseNetworkDeviceFail({ status: response?.data?.status, message: response?.data?.message || 'Failed to pause device.' }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to pause device.');
      yield put(actions.pauseNetworkDeviceFail({ status, message }));
    }
  }
}

export function* unpauseNetworkDeviceSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put({ type: actionTypes.PAUSE_NETWORK_DEVICE_LOADING });
      const response = yield axios.patch('/unPauseDevice', null, {
        params: { masterAcct, wifiType: action.payload.wifiType, deviceMac: action.payload.macAddress },
        validateStatus: () => true
      });
      if (response?.data?.status === 204) {
        yield put(actions.unpauseNetworkDeviceSuccess(response.data));
        yield put(actions.getNetworkDevicePauseState({ macAddress: action.payload.macAddress, wifiType: action.payload.wifiType }));
      } else {
        yield put(actions.unpauseNetworkDeviceFail({ status: response?.data?.status, message: response?.data?.message || 'Failed to unpause device.' }));
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to unpause device.');
      yield put(actions.unpauseNetworkDeviceFail({ status, message }));
    }
  }
}

export function* getIOTNetworkDevicesSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const { wifiType, page } = action.payload;
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.get('/getIOTNetworkDevices', { params: { wifiType, page, masterAcct } });
      if (response?.data?.status === 200) {
        yield put(actions.getIOTssidNetworkDevicesSuccess(response?.data));
      } else {
        yield put(actions.getIOTssidNetworkDevicesFailed());
      }
    } catch (error) {
      const status = error?.response?.status || error?.response?.data?.status || 0;
      const message = error?.response?.data?.message || (!error?.response ? 'Network error. Please check your connection.' : 'Failed to load IOT network devices.');
      yield put(actions.getIOTssidNetworkDevicesFailed({ status, message }));
    }
  }
}
